<nav class="navbar navbar-expand-md navbar-dark bg-light sub-navbar fixed-top">
  <div class="container">
    <button
      type="button"
      class="navbar-toggler"
      data-bs-toggle="collapse"
      data-bs-target="#subNavBarDropdown"
      aria-controls="subNavBarDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand sub-navbar" href="https://conocer.gob.mx/">CONOCER</a>

    <div class="collapse navbar-collapse" id="subNavBarDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link subnav-link" href="#{{opcion1}}">{{ opcion1 | uppercase }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link subnav-link" href="#{{opcion2}}">{{ opcion2 | uppercase }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>